import type { IApiRoutes } from '@/types'

export const API_URL = 'https://hpb-s.com'
export const BASE_API_URL = API_URL + '/api/v1'

export const ApiRoutes: IApiRoutes = {
  articles: {
    articles: '/articles/articles',
    categories: '/articles/categories',
  },
  company: {
    clients: '/company/clients',
    experts: '/company/experts/',
    vacancies: '/company/vacancies',
    competencies: '/company/competencies',
    partners: '/company/partners',
    powers: '/company/powers',
    banners: '/company/banners',
    representations: '/company/representations',
    contact: '/company/contact/',
  },
  news: {
    posts: '/news/posts',
    categories: '/news/categories',
  },
  projects: {
    projects: '/projects/projects',
    categories: '/projects/categories',
  },
  services: {
    services: '/services/services',
    categories: '/services/categories',
  },
  settings: {
    all: '/settings/preferences',
    contacts: '/settings/preferences/?group__name=contacts',
    aboutus: '/settings/preferences/?group__name=aboutus_ru',
    home: '/settings/preferences/?group__name=home',
  },
  search: '/search/',
  metas: (model, key, lang) => `/metas/meta/?model=${model}&key=${key}&lang=${lang}`,
}
